import React from "react";
import { useSelector } from "react-redux";
import { DashSel } from "@/features/dashboard";
import { Select } from "antd";

import { useBenchmarkContext } from "./hook";
import styles from "./styles.less";

export default () => {
  const benchmarkExchanges = useSelector(DashSel.benchmarkExchanges);
  const { exchange, setExchange } = useBenchmarkContext();

  return (
    <Select
      className={styles.exchangeSelect}
      value={exchange}
      placeholder="Select exchange"
      onChange={e => setExchange(e)}
    >
      {benchmarkExchanges
        .filter(e => e !== exchange)
        .map(e => (
          <Select.Option key={e} value={e}>
            {e.toUpperCase()}
          </Select.Option>
        ))}
    </Select>
  );
};
